import styled from '@emotion/styled'
import { Box, IconButton, Typography } from '@material-ui/core'

const Wrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1, 2, 1, 1),
  marginRight: theme.spacing(1.5),
  marginBottom: theme.spacing(1.5),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius * 2,
  backgroundColor: theme.palette.background.paper,
  flexShrink: 0,
  minWidth: 160,
  maxWidth: 240,
}))

type IconTone = 'primary' | 'secondary' | 'error' | 'default'

const IconBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$tone'
})<{ $tone: IconTone }>(({ theme, $tone }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 36,
  height: 36,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: $tone === 'default' ? theme.palette.icon.expandMore : theme.palette[$tone].main,
  color: theme.palette.common.white,
  marginRight: theme.spacing(1.5),
  flexShrink: 0,
}))

const TextContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  flexGrow: 1,
}))

const FileName = styled(Typography)(() => ({
  fontWeight: 500,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontSize: '0.875rem',
}))

const FileMeta = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.75rem',
  marginTop: theme.spacing(0.25),
}))

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: -8,
  right: -8,
  padding: 2,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '& svg': {
    fontSize: '1rem',
  },
}))

export {
  Wrapper,
  IconBox,
  TextContainer,
  FileName,
  FileMeta,
  CloseButton,
}
